import { render, staticRenderFns } from "./SwitchDouble.vue?vue&type=template&id=2c57872d&scoped=true&"
import script from "./SwitchDouble.vue?vue&type=script&lang=js&"
export * from "./SwitchDouble.vue?vue&type=script&lang=js&"
import style0 from "./SwitchDouble.vue?vue&type=style&index=0&id=2c57872d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57872d",
  null
  
)

export default component.exports